























































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Message } from '@/@types/LibraryComponent';
import OrganizationIcon from '@/components/common/OrganizationIcon.vue';
import { AccountParticipationProject } from '@/@types/Account';
import ProfileRatingStar from '@/components/profile/profileParts/ProfileRatingStar.vue';

@Component({
  components: {
    OrganizationIcon,
    ProfileRatingStar,
  },
})
export default class ParticipationProjectCard extends Vue {
  @Prop(Array) public accountParticipationProjects!: Array<
    AccountParticipationProject
  >;
  private menu: boolean = false;
  private OrganizationAvatarSize: number = 32;
  private OrganizationAvatarColor: string = '#fa5f7e';
  /** 参画プロジェクトコメントのAPI設計が未定のため、仮置きのプロパティ */
  private participationProjectComment = 'aaa';
  private participationProjectsLoading: boolean = true;
  /** 参画プロジェクト一覧メッセージ機能のサンプルとして残しておく */
  private projects = [
    {
      project_name: 'セオリー開発',
      project_icon: null,
      project_start_date: '2020/04/01',
      project_end_date: null,
      project_skills: [
        'HTML/CSS/JavaScript',
        'Vue.js',
        'Node.js',
        'MySQL',
        'AWS',
        'Git/ GitHub',
      ],
      project_message: null,
    },
    {
      project_name: 'プロジェクト管理システム',
      project_icon: null,
      project_start_date: '2020/01/01',
      project_end_date: '2020/03/21',
      project_skills: [
        'HTML/CSS/JavaScript',
        'Vue.js',
        'Node.js',
        'MySQL',
        'AWS',
        'Git/ GitHub',
      ],
      project_message: [
        {
          name: 'hoge',
          roll: '管理ユーザー',
          message:
            '今回はありがとうございます。また機会がありましたらよろしくお願いいたします。',
        },
        {
          name: 'huga',
          roll: '一般ユーザー',
          message:
            '今回はありがとうございます。また機会がありましたらよろしくお願いいたします。',
        },
        {
          name: 'foo',
          roll: '一般ユーザー',
          message:
            '今回はありがとうございます。また機会がありましたらよろしくお願いいたします。',
        },
        {
          name: 'bar',
          roll: '一般ユーザー',
          message:
            '今回はありがとうございます。また機会がありましたらよろしくお願いいたします。',
        },
      ],
    },
  ];

  private messageColor(val: Array<Message>): string {
    if (val === null) {
      return 'grey lighten-1';
    }
    return 'light-blue';
  }

  private get reverseParticipationProjectsLoading(): boolean {
    return this.participationProjectsLoading;
  }

  /** アカウント参画プロジェクト内のアカウント評価有無 */
  private isExistProjectEvaluation(
    project: AccountParticipationProject
  ): boolean {
    return (
      project.technicalSkills != null &&
      project.communicationSkills != null &&
      project.understandingSkills != null
    );
  }
}
